import { render, staticRenderFns } from "./credits_services.vue?vue&type=template&id=76676a90&scoped=true"
import script from "./credits_services.vue?vue&type=script&lang=js"
export * from "./credits_services.vue?vue&type=script&lang=js"
import style0 from "./credits_services.vue?vue&type=style&index=0&id=76676a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76676a90",
  null
  
)

export default component.exports